module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_8019.b51d2484.png";